import { useMutation } from '@tanstack/react-query';
import {
  UploadTransactionImageDto,
  UploadTransactionImageEntity,
  WithdrawRequestService,
} from 'services/openapi';

export type UploadTransactionImageType = {
  id: string | undefined;
  param: UploadTransactionImageDto;
};

export const useUploadApproveRequestWithdrawMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<
      UploadTransactionImageEntity,
      Error,
      UploadTransactionImageType & { file: File }
    >({
      mutationFn: (request: UploadTransactionImageType) => {
        return WithdrawRequestService.withdrawRequestControllerUploadTransactionImage(
          request.id ?? '',
          request.param,
        );
      },
      onSuccess: async (data, { file }) => {
        const { sasUrl } = data;

        try {
          const res = await fetch(sasUrl, {
            method: 'PUT',
            headers: {
              'Content-Type': file.type,
              'x-ms-blob-type': 'BlockBlob',
            },
            body: file,
          });

          if (!res.ok) {
            throw error;
          }

          return data;
        } catch (error) {
          throw error;
        }
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
